<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div id="esdLicences" class="subBlockContainer">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()" [showDownload]="true" titleDownload="Download Excel" (downloadEvent)="downloadReports()"></child-header>
    <div class="inner-subBlock-wrapper">
      <!-- <div class="page-title-wrapper">
        <div class="title blade-title">
          {{title}}
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div> -->
      <!-- <div id="basic-info-wrapper">
          <div class="row filter-wrapper">
            <div class="row filter-wrapper margin-l-x15 padding-b-x10">
              <div class="col searchInput-position">
                  <div class="searchInputGroup">
                    <div class="searchIcon">
                      <img src="../../images/new_ui/filter.png">
                    </div>
                    <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                      onblur="this.placeholder='Filter'" [(ngModel)]="searchField">
                  </div>
              </div>
              <div class="col col-small">
                <div id="btnDownload" class="basic-icon download-icon download-icon-position" placement="top" ngbTooltip="Download Excel with licence keys" (click)="downloadReports()"></div>
              </div>
            </div>

          </div>
        </div> -->
      <!-- <div class="top-divider" style="margin-top:0px"></div> -->
      <div class="inner-subBlock-wrapper" *ngIf="loadingFinished && sortedData?.length > 0">
        <div class="row">
          <div class="page-subtitle-wrapper col col-md-9">Reference: {{customerRef}} &nbsp;&nbsp; Order No: {{orderNo}}{{suffix}}
          </div>
          <!-- <div class="col col-md-3 text-right">
            <div id="btnDownload" class="basic-icon download-icon download-icon-position" placement="top"
              ngbTooltip="Download Excel with licence keys and status" (click)="downloadReports()"></div>
          </div> -->
        </div>
        <div class="shared-outer-wrapper table-header-allign">
          <table matSort (matSortChange)="sortData($event)">
            <thead>
              <tr class="row order-title-wrapper">
                <th class="col align-left" style="min-width:28%;" mat-sort-header="stockCode">Stock Code</th>
                <th class="col align-left" style="min-width:20%;" mat-sort-header="description">Description</th>
                <th class="col align-left" style="min-width:15%;" mat-sort-header="token">Token</th>
                <!-- <th class="col align-left" style="min-width:10%;">ORDER NO</th>
                  <th class="col align-center" style="min-width:6%;">QUANTITY</th>
                  <th class="col align-right" style="min-width:15%;">TOTAL(ex GST)</th>
                  <th style="min-width: 6%;"></th> -->
              </tr>
            </thead>
          </table>
        </div>
        <div class="shared-outer-wrapper child-body">
          <table matSort (matSortChange)="sortData($event)">
            <thead hidden="true">
              <tr class="row order-title-wrapper">
                <th class="col align-left" style="min-width:28%;" mat-sort-header="stockCode">Stock Code</th>
                <th class="col align-left" style="min-width:20%;" mat-sort-header="description">Description</th>
                <th class="col align-left" style="min-width:15%;" mat-sort-header="token">Token</th>
                <!-- <th class="col align-left" style="min-width:10%;">ORDER NO</th>
                  <th class="col align-center" style="min-width:6%;">QUANTITY</th>
                  <th class="col align-right" style="min-width:15%;">TOTAL(ex GST)</th>
                  <th style="min-width: 6%;"></th> -->
              </tr>
            </thead>
            <tbody class="scrollable-table-body">
              <ng-container>
                <ng-container
                  *ngFor="let esd of sortedData | TableFilterMultiple:['orderDate', 'euName', 'customerRef'] : searchField">
                  <tr class="row">
                    <td class="col-md align-left" style="min-width:28%;">{{esd?.out_customer_code}}</td>
                    <td class="col-md align-left" style="min-width:20%;">{{esd?.out_stock_desc}}</td>
                    <td class="col-md align-left" style="min-width:15%;">{{esd?.out_sld_token_1}}</td>
                    <!-- <td class="col-md align-left" style="min-width:10%;">{{esd?.out_order_no}}{{esd?.out_bo_suffix}}</td>
                      <td class="col-md align-center" style="min-width:6%;">{{esd?.out_order_qty | number: '1.0-0'}}</td>
                      <td class="col-md align-right" style="min-width:15%;">{{esd?.out_amount | currency:'AUD':'symbol-narrow':'.2-2'}}</td> -->
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>


      <div class="inner-subBlock-wrapper" *ngIf="loadingFinished && sortedData?.length < 1">
        <div class="noData-wrapper">
          <div>
            <img src="../../images/new_ui/no-subscription.png">
          </div>
          <label class="noData-label">
            WE COULDN'T FIND ANY DATA<br />
          </label>
          <br />

        </div>
      </div>

    </div>

    <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)">
    </loading-screen>
  </div>
</div>


<router-outlet></router-outlet>